import Button from "@material-ui/core/Button";
import React, { useEffect, useReducer } from "react";
import getStyles from "./getStyles";
import SummaryPanel from "../SummaryPanel";
import BasketList from "../BasketList";
import ConfirmDialog from "../ConfirmDialog";
import OrderResultsModal from "../OrderResultsModal";
import reducer from "./reducer";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import BackspaceIcon from "@material-ui/icons/Backspace";
import AddIcon from "@material-ui/icons/Add";

import "./NewOrderAndReturn.scss";
import NewOrderAndReturnForm from "../NewOrderAndReturnForm";
import convertToBasketItem from "./convertToBasketItem";

const NewOrderAndReturn = (props: any) => {
  const classes = getStyles();

  const [addToBasketClicked, setAddToBasketClicked] = React.useState<boolean>(
    false
  );

  const [basketItems, setBasketItems] = React.useState<any>([]);

  const [state, dispatch] = useReducer(reducer, {
    openConfirmDialog: false,
    openSubmitDialog: false,
    formValue: {
      currencyAmount: NaN,
      selectedDate: props.defaultRequiredDate,
      settlementSource: "0"
    }
  });

  useEffect(() => dispatch({ type: "SetProps", payload: { ...props } }), [
    props
  ]);

  useEffect(() => {
    if (props.onCurrencyAmountChange) {
      props.onCurrencyAmountChange(
        state.formValue && state.formValue.currencyAmount
      );
    }
  }, [state.formValue && state.formValue.currencyAmount]);

  useEffect(() => {
    if (props.onSettlementSourceChange) {
      props.onSettlementSourceChange(
        state.formValue && state.formValue.settlementSource
      );
    }
  }, [state.formValue && state.formValue.settlementSource]);

  useEffect(() => {
    if (props.onCurrencyChange) {
      props.onCurrencyChange(state.formValue && state.formValue.currency);
    }
  }, [state.formValue && state.formValue.currency]);

  useEffect(() => {
    setBasketItems(props.basketItems);
  }, [props.basketItems]);

  return (
    <div className="NewOrderAndReturn--container">
      <div className="NewOrderAndReturn--order-container">
        <NewOrderAndReturnForm
          returns={props.returns}
          className="NewOrderAndReturn-NewOrderAndReturnForm"
          value={state.formValue}
          deliveryAddress={props.deliveryAddress}
          onSelectBranch={props.onSelectBranch}
          onChange={(value: any) => {
            dispatch({ type: "NewFormValue", payload: value });
          }}
          onChangeDirty={(dirty: boolean) =>
            dispatch({ type: "SetDirty", payload: { isDirty: dirty } })
          }
          isLoadingInitialData={props.isLoadingInitialData}
          isLoadingDenominations={props.isLoadingDenominations}
          isDirty={state.isDirty}
          clickedActionButton={state.clickedActionButton}
          branches={props.branches}
          currencies={props.currencies}
          denominations={props.denominations}
          minRequiredDate={props.defaultRequiredDate}
          addToBasketClicked={addToBasketClicked}
          isFcaCurrency={props.isFcaCurrency}
        />
        <SummaryPanel returns={props.returns} summary={props.summary} />
      </div>
      <div className="NewOrderAndReturn--buttons-container">
        <div className="NewOrderAndReturn--buttons-container-left"></div>
        <div className="NewOrderAndReturn--buttons-container-right">
          <Button
            variant="contained"
            className={`${classes.clearFormButton} NewOrderAndReturn-clearForm`}
            color="secondary"
            startIcon={<BackspaceIcon />}
            onClick={() => dispatch({ type: "Clear" })}
          >
            Clear Form
          </Button>
          <Button
            variant="contained"
            className={`${classes.button} NewOrderAndReturn-addToBasketButton`}
            color="primary"
            startIcon={<AddIcon className="Administration-addIcon" />}
            onClick={() => {
              setAddToBasketClicked(true);
              if (props.returns) {
                // dispatch({ type: "AddToBasketReturns" });
                if (
                  props.onAddToBasket &&
                  state.formValue.branchId &&
                  state.formValue.currency &&
                  state.formValue.currencyAmount
                ) {
                  props.onAddToBasket(
                    convertToBasketItem(
                      state.formValue,
                      state.currencies || [],
                      state.summary
                    )
                  );
                  if (props.onCurrencyChange) {
                    props.onCurrencyChange(null);
                  }
                  if (props.onCurrencyAmountChange) {
                    props.onCurrencyAmountChange(null);
                  }
                  dispatch({ type: "ClearReturnForm" });
                } else {
                  dispatch({ type: "KeepForm" });
                }
              } else {
                // dispatch({ type: "AddToBasketOrders" });
                const currentDenomTotal =
                  state.formValue && state.formValue.denominations
                    ? state.formValue.denominations.reduce(
                        (t: number, n: any) => t + n.orderValue,
                        0
                      )
                    : 0;

                const denomsValid =
                  Math.abs(
                    currentDenomTotal - (state.formValue.currencyAmount || 0)
                  ) < 0.00001;

                if (
                  props.onAddToBasket &&
                  state.formValue.branchId &&
                  state.formValue.currency &&
                  state.formValue.currencyAmount &&
                  state.formValue.denominations &&
                  denomsValid
                ) {
                  props.onAddToBasket(
                    convertToBasketItem(
                      state.formValue,
                      state.currencies || [],
                      state.summary
                    )
                  );
                  if (props.onCurrencyChange) {
                    props.onCurrencyChange(null);
                  }
                  if (props.onCurrencyAmountChange) {
                    props.onCurrencyAmountChange(null);
                  }

                  if (props.onSettlementSourceChange) {
                    props.onSettlementSourceChange(null);
                  }
                  dispatch({ type: "ClearForm" });
                } else {
                  dispatch({ type: "KeepForm" });
                }
              }
            }}
          >
            Add To Basket
          </Button>
        </div>
      </div>

      <div className="NewOrderAndReturn--basket-container">
        <BasketList
          returns={props.returns}
          items={basketItems}
          branches={props.branches}
          onDeleteFromBasket={(item: any) => props.onDeleteFromBasket(item)}
        />
        <div className="NewOrderAndReturn--submit-button-container">
          {basketItems && basketItems.length > 0 ? (
            <Button
              variant="contained"
              className={`${classes.button} NewOrderAndReturn-submit-button`}
              color="primary"
              startIcon={<ArrowUpwardIcon />}
              onClick={() => dispatch({ type: "SubmitBasket" })}
            >
              Submit
            </Button>
          ) : (
            <></>
          )}

          <ConfirmDialog
            returns={props.returns}
            open={state.openConfirmDialog}
            branches={props.branches}
            basketItems={basketItems}
            onCancel={() => dispatch({ type: "CancelSubmitBasket" })}
            onSubmit={() => {
              // dispatch({type: "SubmitOrder"});
              if (props.onConfirmOrder) {
                props.onConfirmOrder();
              }
            }}
          />

          <OrderResultsModal
            open={state.openSubmitDialog && props.submissionResultItems}
            items={props.submissionResultItems}
            onClose={() => dispatch({ type: "Reset" })}
            onReferredOrders={(x: any) => props.onReferredOrders(x)}
          />
        </div>
      </div>
    </div>
  );
};

export default NewOrderAndReturn;
